import React, { useEffect, useState } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { toast } from 'react-toastify';
import AuthLayout from '../../../components/auth/AuthLayout';

const SignupAadhaarUpload = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const { mobile, panDetails } = location.state || {};
  const [frontFile, setFrontFile] = useState(null);
  const [backFile, setBackFile] = useState(null);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    if (!mobile) {
      navigate('/signup', { replace: true });
    }
  }, [mobile, navigate]);

  const handleSubmit = async (event) => {
    event.preventDefault();

    if (!frontFile || !backFile) {
      toast.error('Please upload both front and back images of Aadhaar');
      return;
    }

    setLoading(true);

    try {
      // TODO: Replace with actual API call to upload Aadhaar
      // const response = await authServices.uploadAadhaar(frontFile, backFile);

      await new Promise(resolve => setTimeout(resolve, 1000));

      toast.success('Aadhaar uploaded successfully');
      navigate('/signup/business-details', {
        state: { mobile, panDetails, aadhaarUploaded: true }
      });
    } catch (error) {
      toast.error('Failed to upload Aadhaar. Please try again.');
    } finally {
      setLoading(false);
    }
  };

  return (
    <AuthLayout
      title="Upload Aadhaar"
      subtitle="Upload clear front and back images of your Aadhaar card"
      onBack={() => navigate('/signup/aadhaar', { state: { mobile, panDetails } })}
    >
      <form onSubmit={handleSubmit}>
        <div className="form-group">
          <label className="form-label">Front Image</label>
          <input
            type="file"
            accept="image/*"
            className="form-input"
            onChange={(event) => setFrontFile(event.target.files?.[0] || null)}
            required
          />
        </div>
        <div className="form-group">
          <label className="form-label">Back Image</label>
          <input
            type="file"
            accept="image/*"
            className="form-input"
            onChange={(event) => setBackFile(event.target.files?.[0] || null)}
            required
          />
        </div>
        <button type="submit" className="signin-btn" disabled={loading}>
          {loading ? 'Uploading...' : 'Upload & Continue'}
        </button>
      </form>
    </AuthLayout>
  );
};

export default SignupAadhaarUpload;


